import { boolean } from '@storybook/addon-knobs';

export const useStrictMode = () => boolean('Use React.StrictMode', false);
